export const PERMISOS = {
  RADICACION_DE_FACTURAS: {
    VER_RADICACION: "RADICACION.VER_RADICACION",
    RADICAR_FACTURAS: "RADICACION.RADICAR_FACTURAS",
    SOPORTE_ENTREGA_VER: "RADICACION.SOPORTE_ENTREGA_VER",
    SOPORTE_ENTREGA_ADJUNTAR: "RADICACION.SOPORTE_ENTREGA_ADJUNTAR",
    SOPORTE_ENTREGA_REEMPLAZAR: "RADICACION.SOPORTE_ENTREGA_REEMPLAZAR",
    NOTIFICAR_NOVEDAD: "RADICACION.NOTIFICAR_NOVEDAD",
    ANULAR_FACTURA: "RADICACION.ANULAR_FACTURA",
    NOTIFICAR_NOVEDAD_VER: "RADICACION.NOTIFICAR_NOVEDAD_VER",
    CONSOLIDADO_FACTURACION_VER: "RADICACION.CONSOLIDADO_FACTURACION_VER",
    REPORTE_RADICACION_VER: "RADICACION.REPORTE_RADICACION_VER",
    REPORTE_ANULADOS_VER: "RADICACION.REPORTE_ANULADOS_VER",
    REPORTE_OTROS_PLANES_VER: "RADICACION.REPORTE_OTROS_PLANES_VER",
    HISTORICO_FACTURAS_VER: "RADICACION.HISTORICO_FACTURAS_VER",
    CONSOLIDADOS_MANUALES_VER: "RADICACION.CONSOLIDADOS_MANUALES_VER",
    CONSOLIDADOS_MANUALES_CARGAR: "RADICACION.CONSOLIDADOS_MANUALES_CARGAR",
    SINCRONIZACION_SOPORTES_ENTREGA:
      "RADICACION.SINCRONIZACION_SOPORTES_ENTREGA",
    CONSOLIDADO_PENDIENTES_VER: "RADICACION.CONSOLIDADO_PENDIENTES_VER",
    NOTIFICAR_NOVEDAD_SURA_VER: "RADICACION.NOTIFICAR_NOVEDAD_SURA_VER",
    /** Generar archivo plano forzando estado PENDING + fecha de despacho */
    FORZAR_GENERACION_ARCHIVO_PLANO:
      "RADICACION.FORZAR_GENERACION_ARCHIVO_PLANO",
  },
  /** Procesos administrativos */
  ADMINISTRATIVO: {
    ARCHIVO_PLANO_MASIVO_GENERAR: "RADICACION.ARCHIVO_PLANO_MASIVO_GENERAR",
    VER_SINCRONIZACIONES: "RADICACION.VER_SINCRONIZACIONES",
    EJECUTAR_SINCRONIZACION: "RADICACION.EJECUTAR_SINCRONIZACION",
  },
  /** Maestros transversales (catálogos) */
  MAESTROS: {
    CODIGOS_CIUDAD_VER: "RADICACION.CODIGOS_CIUDAD_VER",
    CODIGOS_CIUDAD_CREAR: "RADICACION.CODIGOS_CIUDAD_CREAR",
    CODIGOS_CIUDAD_ACTUALIZAR: "RADICACION.CODIGOS_CIUDAD_ACTUALIZAR",
    USUARIOS_VER: "RADICACION.USUARIOS_VER",
    USUARIOS_CREAR: "RADICACION.USUARIOS_CREAR",
    USUARIOS_ACTUALIZAR: "RADICACION.USUARIOS_ACTUALIZAR",
    DIRECTORIOS_FARMACIA_VER: "RADICACION.DIRECTORIOS_FARMACIA_VER",
    DIRECTORIOS_FARMACIA_CREAR: "RADICACION.DIRECTORIOS_FARMACIA_CREAR",
    DIRECTORIOS_FARMACIA_ACTUALIZAR:
      "RADICACION.DIRECTORIOS_FARMACIA_ACTUALIZAR",
    IRON_PORTFOLIOS_VER: "RADICACION.CARTERAS_HIERRO_VER",
    IRON_PORTFOLIOS_CREAR: "RADICACION.CARTERAS_HIERRO_CREAR",
    IRON_PORTFOLIOS_ACTUALIZAR: "RADICACION.CARTERAS_HIERRO_ACTUALIZAR",
    HOMOLOGACIONES_INCONSISTENCIAS_SURA_VER:
      "RADICACION.HOMOLOGACIONES_INCONSISTENCIAS_SURA_VER",
    HOMOLOGACIONES_INCONSISTENCIAS_SURA_CREAR:
      "RADICACION.HOMOLOGACIONES_INCONSISTENCIAS_SURA_CREAR",
    HOMOLOGACIONES_INCONSISTENCIAS_SURA_ACTUALIZAR:
      "RADICACION.HOMOLOGACIONES_INCONSISTENCIAS_SURA_ACTUALIZAR",
    TIPOS_AFECTACION_VER: "RADICACION.TIPOS_AFECTACION_VER",
    TIPOS_AFECTACION_CREAR: "RADICACION.TIPOS_AFECTACION_CREAR",
    TIPOS_AFECTACION_ACTUALIZAR: "RADICACION.TIPOS_AFECTACION_ACTUALIZAR",
  },
};
